var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "select",
    {
      attrs: { disabled: _vm.disabled },
      domProps: { value: _vm.value },
      on: { change: _vm.changeHandler },
    },
    [
      _vm.emptyOption
        ? _c("option", { attrs: { value: "" } }, [
            _vm._v(_vm._s(_vm.emptyOption)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.options, function (option) {
        return _c(
          "option",
          {
            key: option.id,
            attrs: { disabled: option.id === "" },
            domProps: { value: option.id, selected: option.id === _vm.value },
          },
          [_vm._v(_vm._s(option.name) + "\n  ")]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }